import { TrackingManager } from '@/lib/tracking/utils/TrackingManager';

export const trackingManager = new TrackingManager();

// Enable tracking by default (respects consent management)
if (typeof window !== 'undefined') {
  trackingManager.enableTracking();
}
